export const MediaType = {
  image: 1,
  video: 2,
  document: 3,
  other: 4,
  metadata: {
    image: 1,
    video: 2,
    damage: 3
  }
} as const;

export const Location = {
  main: {
    id: 0,
    displayName: '3/4 Front (Main Image)',
    priority: 0
  },
  front: {
    id: 1,
    displayName: 'Front',
    priority: 1
  },
  driverSide: {
    id: 2,
    displayName: 'Driver Side',
    priority: 2
  },
  interiorDriverSide: {
    id: 6,
    displayName: 'Interior Driver Side',
    priority: 3
  },
  dashboard: {
    id: 7,
    displayName: 'Dashboard',
    priority: 4
  },
  tire: {
    id: 5,
    displayName: 'Tire',
    priority: 5
  },
  console: {
    id: 8,
    displayName: 'Console',
    priority: 6
  },
  back: {
    id: 3,
    displayName: 'Back',
    priority: 7
  },
  passengerSide: {
    id: 4,
    displayName: 'Passenger Side',
    priority: 8
  },
  other: {
    id: -1,
    displayName: 'Other',
    priority: 9
  }
} as const;

export interface IMedia {
  photos: Array<any>;
  videos: Array<any>;
  meta: object;
}

export const OtherDamageName = {
  interirorDamage: 'Interior Damage',
  exteriorDamage: 'Exterior Damage'
};
